"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.currentState = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.isIdle = true;
        this.status = "idle";
    }
    moveLeft(gameBoard) {
        if (this.getStatus() !== "playing") return;
        const addedTiles = [];
        let isChanged = false;
        for(let i = 1; i < 4; i++){
            for(let j = 0; j < 4; j++)for(let k = 1; k < 4; k++){
                if (this.currentState[j][k - 1] === 0 && this.currentState[j][k] !== 0) {
                    isChanged = true;
                    if (addedTiles.some((tile)=>tile[0] === j && tile[1] === k && tile[2] === this.currentState[j][k])) {
                        addedTiles.push([
                            j,
                            k - 1,
                            this.currentState[j][k]
                        ]);
                        addedTiles.filter((tile)=>{
                            return tile[0] !== j && tile[1] !== k;
                        });
                    }
                    this.currentState[j][k - 1] = this.currentState[j][k];
                    this.currentState[j][k] = 0;
                } else if (this.currentState[j][k - 1] === this.currentState[j][k] && this.currentState[j][k] !== 0) {
                    isChanged = true;
                    if (!addedTiles.some((tile)=>tile[0] === j && tile[1] === k && tile[2] === this.currentState[j][k]) && !addedTiles.some((tile)=>tile[0] === j && tile[1] === k - 1 && tile[2] === this.currentState[j][k - 1])) {
                        const result = this.currentState[j][k] * 2;
                        this.score += result;
                        this.currentState[j][k - 1] = result;
                        this.currentState[j][k] = 0;
                        addedTiles.push([
                            j,
                            k - 1,
                            result
                        ]);
                    }
                }
            }
        }
        if (isChanged) {
            isChanged = false;
            this.addRandomTile();
        }
    }
    moveRight() {
        if (this.getStatus() !== "playing") return;
        const addedTiles = [];
        let isChanged = false;
        for(let i = 1; i < 4; i++){
            for(let j = 0; j < 4; j++)for(let k = 2; k >= 0; k--){
                if (this.currentState[j][k + 1] === 0 && this.currentState[j][k] !== 0) {
                    isChanged = true;
                    if (addedTiles.some((tile)=>tile[0] === j && tile[1] === k && tile[2] === this.currentState[j][k])) {
                        addedTiles.push([
                            j,
                            k + 1,
                            this.currentState[j][k]
                        ]);
                        addedTiles.filter((tile)=>{
                            return tile[0] !== j && tile[1] !== k;
                        });
                    }
                    this.currentState[j][k + 1] = this.currentState[j][k];
                    this.currentState[j][k] = 0;
                } else if (this.currentState[j][k + 1] === this.currentState[j][k] && this.currentState[j][k] !== 0) {
                    isChanged = true;
                    if (!addedTiles.some((tile)=>tile[0] === j && tile[1] === k && tile[2] === this.currentState[j][k]) && !addedTiles.some((tile)=>tile[0] === j && tile[1] === k + 1 && tile[2] === this.currentState[j][k + 1])) {
                        const result = this.currentState[j][k] * 2;
                        this.score += result;
                        this.currentState[j][k + 1] = result;
                        this.currentState[j][k] = 0;
                        addedTiles.push([
                            j,
                            k + 1,
                            result
                        ]);
                    }
                }
            }
        }
        if (isChanged) {
            isChanged = false;
            this.addRandomTile();
        }
    }
    moveUp() {
        if (this.getStatus() !== "playing") return;
        const addedTiles = [];
        let isChanged = false;
        for(let i = 1; i < 4; i++){
            for(let j = 0; j < 4; j++)for(let k = 1; k < 4; k++){
                if (this.currentState[k - 1][j] === 0 && this.currentState[k][j] !== 0) {
                    isChanged = true;
                    if (addedTiles.some((tile)=>tile[0] === k && tile[1] === j && tile[2] === this.currentState[k][j])) {
                        addedTiles.push([
                            k - 1,
                            j,
                            this.currentState[k][j]
                        ]);
                        addedTiles.filter((tile)=>{
                            return tile[0] !== k && tile[1] !== j;
                        });
                    }
                    this.currentState[k - 1][j] = this.currentState[k][j];
                    this.currentState[k][j] = 0;
                } else if (this.currentState[k - 1][j] === this.currentState[k][j] && this.currentState[k][j] !== 0) {
                    isChanged = true;
                    if (!addedTiles.some((tile)=>tile[0] === k && tile[1] === j && tile[2] === this.currentState[k][j]) && !addedTiles.some((tile)=>tile[0] === k - 1 && tile[1] === j && tile[2] === this.currentState[k - 1][j])) {
                        const result = this.currentState[k][j] * 2;
                        this.score += result;
                        this.currentState[k - 1][j] = result;
                        this.currentState[k][j] = 0;
                        addedTiles.push([
                            k - 1,
                            j,
                            result
                        ]);
                    }
                }
            }
        }
        if (isChanged) {
            isChanged = false;
            this.addRandomTile();
        }
    }
    moveDown() {
        if (this.getStatus() !== "playing") return;
        const addedTiles = [];
        let isChanged = false;
        for(let i = 1; i < 4; i++){
            for(let j = 0; j < 4; j++)for(let k = 2; k >= 0; k--){
                if (this.currentState[k + 1][j] === 0 && this.currentState[k][j] !== 0) {
                    isChanged = true;
                    if (addedTiles.some((tile)=>tile[0] === k && tile[1] === j && tile[2] === this.currentState[k][j])) {
                        addedTiles.push([
                            k + 1,
                            j,
                            this.currentState[k][j]
                        ]);
                        addedTiles.filter((tile)=>{
                            return tile[0] !== k && tile[1] !== j;
                        });
                    }
                    this.currentState[k + 1][j] = this.currentState[k][j];
                    this.currentState[k][j] = 0;
                } else if (this.currentState[k + 1][j] === this.currentState[k][j] && this.currentState[k][j] !== 0) {
                    isChanged = true;
                    if (!addedTiles.some((tile)=>tile[0] === k && tile[1] === j && tile[2] === this.currentState[k][j]) && !addedTiles.some((tile)=>tile[0] === k + 1 && tile[1] === j && tile[2] === this.currentState[k + 1][j])) {
                        const result = this.currentState[k][j] * 2;
                        this.score += result;
                        this.currentState[k + 1][j] = result;
                        this.currentState[k][j] = 0;
                        addedTiles.push([
                            k + 1,
                            j,
                            result
                        ]);
                    }
                }
            }
        }
        if (isChanged) {
            isChanged = false;
            this.addRandomTile();
        }
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.currentState;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        if (this.isIdle) {
            this.status = "idle";
            return this.status;
        }
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.currentState[i][j] === 2048) {
                this.status = "win";
                return this.status;
            }
        }
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            const current = this.currentState[i][j];
            if (current === 0 || i > 0 && current === this.currentState[i - 1][j] || i < 3 && current === this.currentState[i + 1][j] || j > 0 && current === this.currentState[i][j - 1] || j < 3 && current === this.currentState[i][j + 1]) {
                this.status = "playing";
                return this.status;
            }
        }
        this.status = "lose";
        return this.status;
    }
    addRandomTile() {
        while(true){
            const row = Math.round(Math.random() * 3);
            const cell = Math.round(Math.random() * 3);
            if (this.currentState[row][cell] === 0) {
                this.currentState[row][cell] = Math.random() * 10 > 1 ? 2 : 4;
                return;
            }
        }
    }
    /**
   * Starts the game.
   */ start() {
        this.isIdle = false;
        this.score = 0;
        for(let i = 0; i < 2; i++)this.addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.isIdle = true;
        this.status = "idle";
        this.currentState = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button, .start");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$hint = $09e991522ca7e64e$var$startMessage.nextElementSibling;
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$gameBoard = document.querySelector("tbody");
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
function $09e991522ca7e64e$var$printBoard() {
    for(let i = 0; i < $09e991522ca7e64e$var$gameBoard.rows.length; i++)for(let j = 0; j < $09e991522ca7e64e$var$gameBoard.rows[i].cells.length; j++){
        const cell = $09e991522ca7e64e$var$gameBoard.rows[i].cells[j];
        const cellValue = $09e991522ca7e64e$var$game.currentState[i][j];
        if ($09e991522ca7e64e$var$game.currentState[i][j] !== 0) {
            cell.textContent = cellValue;
            cell.className = "field-cell";
            cell.classList.add(`field-cell--${cellValue}`);
        } else {
            cell.textContent = "";
            cell.className = "field-cell";
        }
    }
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$game.isIdle = false;
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startMessage.classList.add("hidden");
        $09e991522ca7e64e$var$hint.classList.remove("hidden");
        $09e991522ca7e64e$var$winMessage.classList.add("hidden");
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    } else {
        $09e991522ca7e64e$var$game.isIdle = true;
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$startMessage.classList.remove("hidden");
        $09e991522ca7e64e$var$hint.classList.add("hidden");
        $09e991522ca7e64e$var$winMessage.classList.add("hidden");
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    }
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$printBoard();
});
document.addEventListener("keydown", (e)=>{
    const key = e.key;
    switch(key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            break;
    }
    if (key === "ArrowLeft" || key === "ArrowRight" || key === "ArrowUp" || key === "ArrowDown") $09e991522ca7e64e$var$printBoard();
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    if ($09e991522ca7e64e$var$game.getStatus() === "win") {
        $09e991522ca7e64e$var$hint.classList.add("hidden");
        $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    } else if ($09e991522ca7e64e$var$game.getStatus() === "lose") {
        $09e991522ca7e64e$var$hint.classList.add("hidden");
        $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
    }
});
let $09e991522ca7e64e$var$touchStartX = 0;
let $09e991522ca7e64e$var$touchStartY = 0;
document.addEventListener("touchstart", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") return;
    $09e991522ca7e64e$var$touchStartX = e.touches[0].clientX;
    $09e991522ca7e64e$var$touchStartY = e.touches[0].clientY;
});
document.addEventListener("touchmove", function(e) {
    // Перевіряємо, чи це свайп вниз
    if (e.touches && e.touches.length === 1) // Можна додати додаткову перевірку напрямку свайпу, якщо потрібно
    e.preventDefault();
}, {
    passive: false
});
document.addEventListener("touchend", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") return;
    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const dx = touchEndX - $09e991522ca7e64e$var$touchStartX;
    const dy = touchEndY - $09e991522ca7e64e$var$touchStartY;
    if (Math.abs(dx) > Math.abs(dy)) {
        if (dx >= 50) $09e991522ca7e64e$var$game.moveRight();
        else if (dx <= -50) $09e991522ca7e64e$var$game.moveLeft();
    } else {
        if (dy <= -50) $09e991522ca7e64e$var$game.moveUp();
        else if (dy >= 50) $09e991522ca7e64e$var$game.moveDown();
    }
    $09e991522ca7e64e$var$printBoard();
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    if ($09e991522ca7e64e$var$game.getStatus() === "win") {
        $09e991522ca7e64e$var$hint.classList.add("hidden");
        $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    } else if ($09e991522ca7e64e$var$game.getStatus() === "lose") {
        $09e991522ca7e64e$var$hint.classList.add("hidden");
        $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
    }
});


//# sourceMappingURL=index.173befc9.js.map
